import { usersOrganisationsRolesQueryOptions } from "@/features/auth/api/selectUsersOrganisationsRoles";
import { requireTab } from "@/features/navigation/requireTab";
import { validationByIdQueryOptions } from "@/features/validations/api/selectValidationById";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/validate/$validationId")({
    component: () => <Outlet />,
    beforeLoad: async ({ context }) => {
        const userId = context?.auth?.id;
        if (!userId || !context?.queryClient) {
            throw redirect({ to: "/login" });
        }

        const roles = await context.queryClient.ensureQueryData(usersOrganisationsRolesQueryOptions(userId));
        context.auth.roles.setRoles(roles ?? []);

        await requireTab(context, "validate");

        return context;
    },
    loader: async ({ context, params }) => {
        await context?.queryClient.ensureQueryData(validationByIdQueryOptions(params.validationId));
    },
});
